/**
 * User-Friendly Help Article Template
 * 
 * This template provides a pre-filled starting point for non-technical users
 * with clear [REPLACE THIS] markers and helpful comments.
 */

export const NEW_ARTICLE_HTML_TEMPLATE = `<article class="help-article">
  <div class="help-article-intro">
    <p>[REPLACE THIS: Write a brief introduction that explains what this article covers and who it's for]</p>
  </div>

  <h2>[REPLACE THIS: First Section Title]</h2>
  <p>[REPLACE THIS: Explain the main concept or feature here. Keep paragraphs short and focused on a single idea]</p>
  <p>[REPLACE THIS: Add additional details as needed. Use simple, direct language]</p>

  <h2>[REPLACE THIS: Second Section Title]</h2>
  <p>[REPLACE THIS: Content for second section]</p>
  <p>[REPLACE THIS: More details here]</p>

  <h2>Key Points</h2>
  <ul>
    <li><strong>Point One:</strong> [REPLACE THIS: Describe the first key point]</li>
    <li><strong>Point Two:</strong> [REPLACE THIS: Describe the second key point]</li>
    <li><strong>Point Three:</strong> [REPLACE THIS: Describe the third key point]</li>
  </ul>

  <!-- OPTIONAL: To add a callout box for important information -->
  <!-- <div class="help-callout">
    <h3>Important Note</h3>
    <p>Your important message here</p>
  </div> -->

  <!-- OPTIONAL: To add an image -->
  <!-- <img src="YOUR_IMAGE_URL" alt="Description of image" class="help-article-image"> -->
  <!-- <p class="help-article-image-caption">Caption for image (optional)</p> -->

  <!-- OPTIONAL: To add a link -->
  <!-- <a href="URL">Link Text</a> -->
</article>`;

/**
 * HTML Formatting Guide content for display in the editor
 */
export const HTML_FORMATTING_GUIDE = {
  intro: "Replace all [REPLACE THIS] markers with your actual content. You can add sections, remove sections, or use the optional templates commented out. Keep HTML tags (<h2>, <p>, <ul>, etc.) intact.",
  tags: [
    { tag: "<h2>Your Heading</h2>", description: "Section headings" },
    { tag: "<p>Your paragraph text</p>", description: "Paragraphs" },
    { tag: "<strong>Bold text</strong>", description: "Bold text" },
    { tag: "<em>Italic text</em>", description: "Italic text" },
    { tag: "<ul><li>Item</li></ul>", description: "Bullet lists" },
    { tag: "<ol><li>Item</li></ol>", description: "Numbered lists" },
    { tag: '<a href="URL">Link text</a>', description: "Links" },
  ],
};

/**
 * Default content blocks for new articles using the block-based editor
 */
export function createDefaultContentBlocks() {
  return [
    {
      id: crypto.randomUUID(),
      type: "paragraph" as const,
      content: "Write a brief introduction that explains what this article covers and who it's for.",
    },
    {
      id: crypto.randomUUID(),
      type: "heading" as const,
      level: 2 as const,
      content: "Getting Started",
    },
    {
      id: crypto.randomUUID(),
      type: "paragraph" as const,
      content: "Explain the main concept or feature here. Keep paragraphs short and focused on a single idea.",
    },
    {
      id: crypto.randomUUID(),
      type: "heading" as const,
      level: 2 as const,
      content: "Key Points",
    },
    {
      id: crypto.randomUUID(),
      type: "paragraph" as const,
      content: "<ul><li><strong>Point One:</strong> Describe the first key point</li><li><strong>Point Two:</strong> Describe the second key point</li><li><strong>Point Three:</strong> Describe the third key point</li></ul>",
    },
  ];
}
